export default "__VITE_ASSET__kO7cUt____"